
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '105%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
      
    },
    nested: {
        paddingLeft: theme.spacing(3),
    },
}));


export default useStyles;